<app-carousel
    [typeSearch]="'Employee'"
></app-carousel>
<div class="body-app mt-3 mb-3">
    <div class="content-app">
        <div class="row">
            <div class="col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12">
                <div class="mt-5">
                    <div class="row mb-2">
                        <div class="col-md-6 col-sm-6 col-12">
                            <h5 class="mt-2 mb-2">
                                <i class="fa-regular fa-address-card"></i>
                                Mis Curriculum 
                            </h5>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12">
                            <div class="text-end">
                                <button type="button" class="btn btn-primary" routerLink="/candidates/create-cv">
                                    <i class="fa-regular fa-square-plus"></i>
                                    Nuevo
                                </button>
                            </div>
                        </div>
                    </div>
                    <ul class="list-group" [ngClass]="{'list-container': resumes().length > 5}">
                        <li class="list-group-item list-group-item-job" *ngFor="let item of resumes()">
                            <div class="row">
                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-12">
                                    <div class="w-100 h-100 d-flex align-items-center justify-content-center">
                                        <div class="mt-2 mb-2">
                                            <i class="{{ item.typeId === resumeType.WEB ? 'fa-regular fa-address-card fa-5x text-primary' : 'fa-regular fa-file-pdf fa-5x text-primary' }}"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-10 col-lg-10 col-md-10 col-sm-9 col-12">
                                    <div class="row mb-2">
                                        <div class="col-md-8 col-sm-12 col-12">
                                            <div class="d-flex align-items-center">
                                                <a routerLink="/candidates/cv" class="text-decoration-none fs-5 mt-0 mb-0">
                                                    {{ item.name }}
                                                </a>
                                                <span *ngIf="item.isDefault" class="badge bg-warning text-dark ms-2 d-flex align-items-center" title="Currículum por defecto" style="font-size: 0.8rem; padding: 0.4rem 0.6rem;">
                                                    <i class="fa-solid fa-star me-1 text-warning" style="filter: drop-shadow(0 0 1px #000);"></i> Predeterminado
                                                </span>
                                            </div>
                                            <p class="mt-0 mb-2">
                                                {{item.description}}
                                            </p>
                                        </div>
                                        <div class="col-md-4 col-sm-12 col-12">
                                            <div class="text-end">
                                                <ul class="list-group">
                                                    <!-- <li class="list-group-item d-flex justify-content-between align-items-start">
                                                        <div class="ms-0 me-auto">
                                                            Visualizaciones
                                                        </div>
                                                        <span class="badge text-bg-primary rounded-pill">{{item.views | number}}</span>
                                                    </li> -->
                                                    <li class="list-group-item d-flex justify-content-between align-items-start">
                                                        <div class="ms-0 me-auto">
                                                            Ofertas aplicadas
                                                        </div>
                                                        <span class="badge text-bg-primary rounded-pill">{{item.offersApplied | number}}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-6 col-sm-12 col-12">
                                            <i class="fa-regular fa-calendar text-primary"></i>
                                            Ultima modificación
                                            {{ (item.modifyDate || item.createDate) | date : 'dd/MM/yyyy' }}
                                        </div>
                                        <div class="col-md-6 col-sm-12 col-12">
                                            <div class="mt-2 mb-2 text-end">
                                                <button (click)="editResume(item)" type="button" class="btn btn-outline-primary me-2" routerLink="/candidates/cv">
                                                    <i class="fa-solid fa-pen-to-square"></i>
                                                    Editar
                                                </button>
                                                <button type="button" class="btn btn-outline-secondary me-2" title="Compartir" data-bs-toggle="modal" data-bs-target="#modalCompartir">
                                                    <i class="fa-solid fa-share-from-square"></i>
                                                </button>
                                                <button (click)="viewResume(item)" type="button" class="btn btn-outline-success me-2" title="Previsualizar" routerLink="/candidates/cv-preview">
                                                    <i class="fa-solid fa-eye"></i>
                                                </button>
                                                <button type="button" class="btn btn-outline-danger" (click)="deleteCv(item.id)">
                                                    <i class="fa-solid fa-trash-can"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12">
                <!-- <div class="mt-5">
                    <h5 class="mt-2 mb-2">
                        <i class="fa-regular fa-square-check"></i>
                        Evaluaciones
                    </h5>
                    <ul class="list-group">
                        <li class="list-group-item list-group-item-job" *ngFor="let item of [{
                            evaluacion: 'Evaluación psicológica',
                            descripcion: 'Un breve test psicológico'
                        },{
                            evaluacion: 'Test de personalidad',
                            descripcion: 'Un test para conocerte mejor'
                        }]">
                            <a [routerLink]="['/candidates/test-detail']" class="text-decoration-none fs-6 mt-0 mb-0">
                                {{ item.evaluacion }}
                            </a>
                            <p class="mt-0 mb-2">
                                {{ item.descripcion }}
                            </p>
                            <div class="text-end mt-2 mb-2">
                                <button [routerLink]="['/candidates/test-detail']" type="button" class="btn btn-primary btn-sm">
                                    Realizar test
                                </button>
                            </div>
                        </li>
                    </ul>
                </div> -->
            </div>
        </div>
    </div>
</div>